function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}


class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}


document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});


const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => {
    if (!video.closest('.autoplaying-video')) {
      video.pause();
    }
  });
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);




class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);



// Variant Selector Drawer
function initVariantDrawer() {
  const toggles = document.querySelectorAll('.radio-drawer--opener');
  const drawers = document.querySelectorAll('.radio-options-drawer');
  const closeButtons = document.querySelectorAll('.rod--drawer-close');
  const closeButtonsFooter = document.querySelectorAll('.rod--drawer-footer-button');
  const backgrounds = document.querySelectorAll('.radio-options-drawer--background');

  toggles.forEach(function (toggle, index) {
    const drawer = drawers[index];
    const closeButton = closeButtons[index];
    const closeButtonFooter = closeButtonsFooter[index];
    const drawerBg = backgrounds[index];

    if (!drawer) return;

    const isAccordion = drawer.classList.contains('ro-display-type--accordion');

    // If accordion, set up localStorage key
    let drawerKey;
    if (isAccordion) {
      const productId = document.querySelector('[data-product-id]')?.dataset.productId || 'unknown';
      drawerKey = `drawerOpen-${productId}-${index}`;

      // Restore open state from localStorage
      if (window.location.search.includes('variant=') && localStorage.getItem(drawerKey) === 'true') {
        drawer.classList.add('open');
        if (drawerBg) drawerBg.classList.add('open');
      }
    }

    const closeDrawer = () => {
      drawer.classList.remove('open');
      if (drawerBg) drawerBg.classList.remove('open');
      if (isAccordion) localStorage.setItem(drawerKey, 'false');
    };

    if (drawerBg) drawerBg.addEventListener("click", closeDrawer);
    if (closeButtonFooter) closeButtonFooter.addEventListener("click", closeDrawer);
    if (closeButton) closeButton.addEventListener("click", closeDrawer);

    toggle.addEventListener("click", function () {
      const isOpen = drawer.classList.toggle('open');
      if (drawerBg) drawerBg.classList.toggle('open', isOpen);
      if (isAccordion) localStorage.setItem(drawerKey, isOpen.toString());
    });
  });
}

document.addEventListener("DOMContentLoaded", initVariantDrawer);


// Accordion Component
document.addEventListener("DOMContentLoaded", function () {
  // Get all elements with class "accordion-title"
  var headings = document.querySelectorAll(".accordion-title");

  // Loop through each heading element
  headings.forEach(function (heading) {
    // Get the corresponding panel
    var panel = heading.nextElementSibling;

    // Temporarily disable transitions for initialization
    panel.style.transition = "none";

    // Check if the panel is open by default
    if (panel.classList.contains("panel-open")) {
      // Set height to match content for open panels
      panel.style.height = panel.scrollHeight + "px";
    }

    // Re-enable transitions after initialization
    setTimeout(() => {
      panel.style.transition = ""; // Remove inline transition style
    });

    // Add a click event listener to each accordion heading
    heading.addEventListener("click", function () {
      if (panel.classList.contains("panel-open")) {
        // Close the panel
        panel.style.height = null;
        panel.classList.remove("panel-open");
        panel.setAttribute("aria-hidden", "true");
        heading.classList.remove("active");
        heading.setAttribute("aria-expanded", "false");
      } else {
        // Open the panel
        panel.style.height = panel.scrollHeight + "px";
        panel.classList.add("panel-open");
        panel.setAttribute("aria-hidden", "false");
        heading.classList.add("active");
        heading.setAttribute("aria-expanded", "true");
      }
    });
  });
});



// Slider Component

function LuxeSlider() {
  const sliderWrappers = document.querySelectorAll('.slider-outer-wrapper');

  sliderWrappers.forEach(wrapper => {
    const sliderContainer = wrapper.querySelector('.slider-element');
    const leftArrow = wrapper.querySelector('.slider-arrows .slider-arrow-left');
    const rightArrow = wrapper.querySelector('.slider-arrows .slider-arrow-right');

    if (!sliderContainer) return;

    let scrollAmount = 300; // Fallback

    function calculateScrollAmount() {
      let gridItems = sliderContainer.querySelectorAll('.grid-item');

      // Fallback to .grid__item if .grid-item is not present
      if (!gridItems.length) {
        gridItems = sliderContainer.querySelectorAll('.grid__item');
      }

      if (gridItems.length >= 2) {
        const rect1 = gridItems[0].getBoundingClientRect();
        const rect2 = gridItems[1].getBoundingClientRect();
        // Distance between items (includes gap/margins)
        scrollAmount = Math.abs(rect2.left - rect1.left);
      } else if (gridItems.length === 1) {
        const rect = gridItems[0].getBoundingClientRect();
        scrollAmount = rect.width;
      } else {
        scrollAmount = 300; // no items found, keep Fallback
      }
    }

    function setArrowState() {
      // Find the first image element within the slider-element
      const firstImage = sliderContainer.querySelector('img');
      const placeholder = sliderContainer.querySelector('.global-image-placeholder');
    
      let imageHeight = 0;
      if (firstImage) {
        // Get the height of the first image
        imageHeight = firstImage.clientHeight;
      } else if (placeholder) {
        // If there is no image but a placeholder, get its height
        imageHeight = placeholder.clientHeight;
      }
      
      const scrollPosition = sliderContainer.scrollLeft;
      const containerWidth = sliderContainer.clientWidth;
      const totalWidth = sliderContainer.scrollWidth;
      const scrollLimit = totalWidth - containerWidth;
      const scrollLimitWithOffset = scrollLimit - 1;

      // Apply top margin to arrows based on half of the image height
      if (wrapper.classList.contains('slider-arrows-position-middle') && leftArrow && rightArrow && imageHeight !== 0 && !Shopify.designMode) {
        const marginTop = (imageHeight * 0.5) - 24;
        leftArrow.style.marginTop = marginTop + 'px';
        rightArrow.style.marginTop = marginTop + 'px';
      }
      
      if (leftArrow && rightArrow) {
        if (scrollPosition === 0) {
          leftArrow.classList.add('disabled');
        } else {
          leftArrow.classList.remove('disabled');
        }
  
        if (scrollPosition === scrollLimit || scrollPosition >= scrollLimitWithOffset) {
          rightArrow.classList.add('disabled');
        } else {
          rightArrow.classList.remove('disabled');
        }
      }
    }

    // Initial calculations
    calculateScrollAmount();
    setArrowState();

    sliderContainer.addEventListener('scroll', setArrowState);

    // Event listener for window resize
    window.addEventListener('resize', () => {
      calculateScrollAmount();
      setArrowState();
    });

    if (leftArrow) {
      leftArrow.addEventListener('click', () => {
        sliderContainer.scrollBy({
          top: 0,
          left: -scrollAmount,
          behavior: 'smooth'
        });
      });
    }

    if (rightArrow) {
      rightArrow.addEventListener('click', () => {
        sliderContainer.scrollBy({
          top: 0,
          left: scrollAmount,
          behavior: 'smooth'
        });
      });
    }
  });
}

// Call the function when the DOM is ready
document.addEventListener('DOMContentLoaded', LuxeSlider);



// Video

document.addEventListener('DOMContentLoaded', function() {

  // Function to pause all media except those within autoplaying-video div
  function pauseOtherMedia(except) {
  var mediaElements = document.querySelectorAll('video, audio');
  mediaElements.forEach(function (media) {
    const hasAutoplay =
      media.hasAttribute('autoplay') &&
      media.getAttribute('autoplay') !== 'false';

    if (media !== except && !hasAutoplay) {
      media.pause();
    }
  });

  // Pause all embedded YouTube and Vimeo videos
  document.querySelectorAll('.iframe-youtube').forEach((video) => {
  video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.evp-vimeo iframe').forEach((iframe) => {
    if (iframe.closest('.evp-vimeo')) {
      iframe.contentWindow.postMessage('{"method":"pause"}', '*');
    }
  });
}

  // Add click event listener to all video player posters
  document.querySelectorAll('.video-player-sh--poster').forEach(function(poster) {
    poster.addEventListener('click', function() {
      // Hide the poster
      poster.classList.add('poster-hidden');

      // Find the associated video element
      var video = poster.nextElementSibling;

      // Pause all other media except current video
      pauseOtherMedia(video);

      // window.pauseAllMedia();

      // Play current video
      video.play();
      video.controls = true;
    });
  });

  // Add event listener for playing media elements
  document.addEventListener('play', function(event) {
    var playingMedia = event.target;

    // Pause all other media except playing media element
    if (!playingMedia.closest('.autoplaying-video')) {
      pauseOtherMedia(playingMedia);
    }
  }, true); // Use capture phase to ensure event is caught before bubbling
});


// Video banners play and pause controls

const playbackButtons = document.querySelectorAll('.video-controls--pause-playback');

if (playbackButtons.length > 0) {
  playbackButtons.forEach(button => {
    button.addEventListener('click', function () {
      const section = button.closest('.section-inner');
      if (!section) return;

      const videos = section.querySelectorAll('video');

      let anyPaused = false;

      videos.forEach(video => {
        if (video.paused) {
          anyPaused = true;
        }
      });

      videos.forEach(video => {
        if (anyPaused) {
          video.play();
          button.classList.add('playing');
        } else {
          video.pause();
          button.classList.remove('playing');
        }
      });
    });
  });
}

// Video banners audio controls

const videoAudioButtons = document.querySelectorAll('.video-controls--audio');

if (videoAudioButtons.length > 0) {
  videoAudioButtons.forEach(button => {
    button.addEventListener('click', function () {
      const section = button.closest('.section-inner');
      if (!section) return;

      const videos = section.querySelectorAll('video');
      if (!videos.length) return;

      // Check if any video in this section is muted
      const anyMuted = Array.from(videos).some(video => video.muted);

      if (anyMuted) {
        // Mute all other videos on the page first
        document.querySelectorAll('video').forEach(video => {
          video.muted = true;
        });

        // Unmute this section's videos
        videos.forEach(video => {
          video.muted = false;
        });

        button.classList.add('audio-on');
      } else {
        // Turn audio off for this section
        videos.forEach(video => {
          video.muted = true;
        });

        button.classList.remove('audio-on');
      }
    });
  });
}




// Hotspots

const hotspotButtons = document.querySelectorAll('.hotspot-button');

hotspotButtons.forEach(button => {
  button.addEventListener('click', () => {
    // Close all other open hotspot-info panels
    const allHotspotInfos = document.querySelectorAll('.hotspot-info');
    allHotspotInfos.forEach(info => {
      info.classList.remove('open');
      info.classList.add('hidden');
    });

    // Find the next sibling element with the class 'hotspot-info'
    const hotspotInfo = button.nextElementSibling;

    // Check if the next sibling is the .hotspot-info and add the 'open' class
    if (hotspotInfo && hotspotInfo.classList.contains('hotspot-info')) {
      hotspotInfo.classList.add('open');
      hotspotInfo.classList.remove('hidden');
    }

    // Find the close button within the hotspot-info and add a click event listener
    const closeButton = hotspotInfo.querySelector('.hotspot-close-button');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        // Remove the 'open' class when the close button is clicked
        hotspotInfo.classList.remove('open');
        hotspotInfo.classList.add('hidden');
      });
    }
  });
});



// Slider custom scrollbar

document.querySelectorAll('.slider-outer-wrapper').forEach(wrapper => {
  const slider = wrapper.querySelector('.slider-element');
  const track = wrapper.querySelector('.slider-custom-scrollbar-track');
  const trackwrapper = wrapper.querySelector('.slider-custom-scrollbar-track-wrapper');
  const marker = wrapper.querySelector('.slider-custom-scrollbar-marker');

  if (!slider || !track || !marker) return;

  function updateMarkerWidthAndVisibility() {
    const visibleWidth = slider.clientWidth;
    const scrollableWidth = slider.scrollWidth;

    if (scrollableWidth <= visibleWidth) {
      trackwrapper.classList.add('hidden');
    } else {
      trackwrapper.classList.remove('hidden');
      const trackWidth = track.clientWidth;
      const markerWidth = (visibleWidth / scrollableWidth) * trackWidth;
      marker.style.width = `${markerWidth}px`;
    }
  }

  function updateMarkerPosition() {
    const scrollLeft = slider.scrollLeft;
    const scrollableWidth = slider.scrollWidth - slider.clientWidth;
    const trackWidth = track.clientWidth - marker.clientWidth;

    const left = (scrollableWidth > 0) ? (scrollLeft / scrollableWidth) * trackWidth : 0;
    marker.style.transform = `translateX(${left}px)`;
  }

  // Initial setup
  updateMarkerWidthAndVisibility();
  updateMarkerPosition();

  // On scroll
  slider.addEventListener('scroll', updateMarkerPosition);

  // On window resize
  window.addEventListener('resize', () => {
    updateMarkerWidthAndVisibility();
    updateMarkerPosition();
  });
});



// Swipable product cards

function updateCardArrowState(arrowLeft, arrowRight, swipeTrack) {
  const maxScrollLeft = swipeTrack.scrollWidth - swipeTrack.clientWidth;
  const buffer = 2; // Small buffer to account for rounding

  // Add 'faded' class if scroll is at the start or end
  if (swipeTrack.scrollLeft <= 0) {
    arrowLeft.classList.add('faded');
  } else {
    arrowLeft.classList.remove('faded');
  }

  if (swipeTrack.scrollLeft >= maxScrollLeft - buffer) {
    arrowRight.classList.add('faded');
  } else {
    arrowRight.classList.remove('faded');
  }
}

function initializeSwipeFunctionality(container = document) {

  // Swipable product cards - card media pagination
  document.querySelectorAll('.card-product--image-swipe-container').forEach(function (container) {
    const swipeTrack = container.querySelector('.card-product--image-swipe-track');
    const bullets = container.querySelectorAll('.product-card--pagination-bullet');
    const slides = swipeTrack.querySelectorAll('.card-product--image-slide');
  
    if (swipeTrack && bullets.length && slides.length) {
      const updatePagination = () => {
        // Determine the active slide based on scroll position
        const trackScrollLeft = swipeTrack.scrollLeft;
        const trackWidth = swipeTrack.clientWidth;
  
        slides.forEach((slide, index) => {
          const slideLeft = slide.offsetLeft;
          const slideWidth = slide.offsetWidth;
          const scrollAmount = Math.round(slideWidth / 2);
  
          if (
            trackScrollLeft >= slideLeft - scrollAmount &&
            trackScrollLeft < slideLeft + scrollAmount
          ) {
            // Update active class on bullets
            bullets.forEach((bullet) => bullet.classList.remove('active'));
            const bullet = container.querySelector(`.product-card--pagination-bullet[data-value="${index + 1}"]`);
            if (bullet) bullet.classList.add('active');
          }
        });
      };
  
      // Attach scroll event listener to update pagination
      swipeTrack.addEventListener('scroll', updatePagination);
  
      // Initial update on page load
      updatePagination();
    }
  });
  
  // Swipable product cards - Arrows
  document.querySelectorAll('.card-product--image-swipe-container').forEach(function (container) {
    const swipeTrack = container.querySelector('.card-product--image-swipe-track');
    const arrowLeft = container.querySelector('.pcpa-left');
    const arrowRight = container.querySelector('.pcpa-right');

    if (swipeTrack && arrowLeft && arrowRight) {      
      // Add click event listener for left arrow
      arrowLeft.addEventListener('click', function (event) {
        event.preventDefault();
        const slide = swipeTrack.querySelector('.card-product--image-slide');
        const slideWidth = slide ? slide.offsetWidth : 100;
        const swipeAmount = Math.round(slideWidth / 1);
        swipeTrack.scrollBy({ left: -swipeAmount, behavior: 'smooth' });
      });

      // Add click event listener for right arrow
      arrowRight.addEventListener('click', function (event) {
        event.preventDefault();
        const slide = swipeTrack.querySelector('.card-product--image-slide');
        const slideWidth = slide ? slide.offsetWidth : 100;
        const swipeAmount = Math.round(slideWidth / 1);
        swipeTrack.scrollBy({ left: swipeAmount, behavior: 'smooth' });
      });

      // Add scroll event listener to update arrow states dynamically
      swipeTrack.addEventListener('scroll', function () {
        updateCardArrowState(arrowLeft, arrowRight, swipeTrack);
      });

      // Initial arrow state update on page load
      updateCardArrowState(arrowLeft, arrowRight, swipeTrack);
    }
  });  
}

// Call the function on page load
initializeSwipeFunctionality();

(function () {
  function normalizeText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function getPairingsData(sectionId) {
    const script = document.getElementById(`ProductPairingsData-${sectionId}`);
    if (!script) return [];

    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      console.error('Invalid product pairing JSON:', error);
      return [];
    }
  }

  function getSelectedColorFromVariant(variant, colorOptionPosition) {
    if (!variant || !colorOptionPosition) return '';

    const optionKey = `option${colorOptionPosition}`;
    return variant[optionKey] || '';
  }

  function renderPairings(sectionId, selectedColor) {
    const wrapper = document.getElementById(`ProductPairings-${sectionId}`);
    if (!wrapper) return;

    const itemsContainer = wrapper.querySelector('.product-pairings__items');
    if (!itemsContainer) return;

    const pairings = getPairingsData(sectionId);
    const matchedPairing = pairings.find(function (pairing) {
      return normalizeText(pairing.trigger_color) === normalizeText(selectedColor);
    });

    if (!matchedPairing || !matchedPairing.items || !matchedPairing.items.length) {
      wrapper.hidden = true;
      itemsContainer.innerHTML = '';
      return;
    }

    itemsContainer.innerHTML = matchedPairing.items
      .map(function (item, index) {
        const imageHtml = item.image
          ? `<a href="${item.url || '#'}"><img class="product-pairings__image" src="${item.image}" alt="${item.title || ''}" loading="lazy"></a>`
          : `<div class="product-pairings__image"></div>`;

        return `
          <div class="product-pairings__item" data-pairing-index="${index}">
            ${imageHtml}

            <div class="product-pairings__info">
              <a href="${item.url || '#'}" class="product-pairings__title">
                ${item.title || ''}
              </a>
              ${item.variant_title ? `<span class="product-pairings__color">${item.variant_title}</span>` : ''}
            </div>

            <div class="product-pairings__qty">
              <button type="button" class="product-pairings__qty-minus" aria-label="Decrease quantity">−</button>
              <input type="number" class="product-pairings__qty-input" value="1" min="1">
              <button type="button" class="product-pairings__qty-plus" aria-label="Increase quantity">+</button>
            </div>

            <button
              type="button"
              class="product-pairings__add button button--solid"
              data-variant-id="${item.variant_id || ''}"
            >
              Add
            </button>
          </div>
        `;
      })
      .join('');

    wrapper.hidden = false;
  }

  function initPairingQuantityControls() {
    document.addEventListener('click', function (event) {
      const minusButton = event.target.closest('.product-pairings__qty-minus');
      const plusButton = event.target.closest('.product-pairings__qty-plus');

      if (!minusButton && !plusButton) return;

      const qtyWrapper = event.target.closest('.product-pairings__qty');
      if (!qtyWrapper) return;

      const input = qtyWrapper.querySelector('.product-pairings__qty-input');
      if (!input) return;

      let currentValue = parseInt(input.value, 10) || 1;

      if (minusButton) {
        currentValue = Math.max(1, currentValue - 1);
      }

      if (plusButton) {
        currentValue = currentValue + 1;
      }

      input.value = currentValue;
    });
  }

  function initPairingAddToCart() {
      document.addEventListener('click', function (event) {
        const addButton = event.target.closest('.product-pairings__add');
        if (!addButton) return;

        const variantId = addButton.dataset.variantId;
        const itemRow = addButton.closest('.product-pairings__item');
        const qtyInput = itemRow ? itemRow.querySelector('.product-pairings__qty-input') : null;
        const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        if (!variantId) {
          alert('Variant ID missing for this paired product.');
          return;
        }

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        addButton.disabled = true;
        addButton.textContent = 'Adding...';

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);

        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);

          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(document.activeElement);
          }
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.status) {
              throw response;
            }

            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }

            addButton.textContent = 'Added';

            setTimeout(function () {
              addButton.textContent = 'Add';
              addButton.disabled = false;
            }, 1200);
          })
          .catch(function (error) {
            console.error('Pairing add to cart error:', error);
            addButton.textContent = 'Add';
            addButton.disabled = false;
            alert(error.description || 'Could not add this item to cart.');
          });
      });
    }

  function initPairingsOnPageLoad() {
    document.querySelectorAll('[id^="ProductPairings-"]').forEach(function (wrapper) {
      const sectionId = wrapper.id.replace('ProductPairings-', '');
      const productInfo = document.getElementById(`MainProduct-${sectionId}`);
      if (!productInfo) return;

      const selectedVariantScript = productInfo.querySelector('variant-selects [data-selected-variant]');
      if (!selectedVariantScript) return;

      let variant = null;

      try {
        const variantJson = selectedVariantScript.textContent.trim();
        if (!variantJson) return;
        variant = JSON.parse(variantJson);
      } catch (error) {
        console.error('Could not parse selected variant for pairings:', error);
        return;
      }

      if (!variant) return;

      const colorOptionPosition = parseInt(wrapper.dataset.colorOptionPosition, 10) || 1;
      const selectedColor = getSelectedColorFromVariant(variant, colorOptionPosition);

      renderPairings(sectionId, selectedColor);
    });
  }

  function initPairingsOnVariantChange() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      console.warn('Product pairing script: Shopify pub/sub not found.');
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const data = event && event.data ? event.data : {};
      const sectionId = data.sectionId;
      const variant = data.variant;

      if (!sectionId || !variant) return;

      const wrapper = document.getElementById(`ProductPairings-${sectionId}`);
      if (!wrapper) return;

      const colorOptionPosition = parseInt(wrapper.dataset.colorOptionPosition, 10) || 1;
      const selectedColor = getSelectedColorFromVariant(variant, colorOptionPosition);

      renderPairings(sectionId, selectedColor);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPairingQuantityControls();
    initPairingAddToCart();
    initPairingsOnPageLoad();
    initPairingsOnVariantChange();
  });
})();